import { TagContent, TagTableData } from "../models/countries-interface";
import { api } from "../utils/api";

export const TagApi = {
  updateTag: async (id: string, tag: any): Promise<TagContent> => {
	return await api.post(`Content/UpdateTag/${id}`, tag);
  },
  createTag: async (tag: any): Promise<TagContent> => {
	return await api.post(`Content/CreateTag`, tag);
  },
  getTags: async (): Promise<TagTableData[]> => {
	return await api.get(`Content/Tags`);
  },
  getTagTypes: async (): Promise<string[]> => {
	return await api.get(`Content/TagTypes`);
  },
  getTagIcons: async (): Promise<string[]> => {
	return await api.get(`Content/TagIcons`);
  },
};